<div class="float-right">
  <p class="d-block d-sm-none">
    XS
  </p>
  <p class="d-none d-sm-block d-md-none">
    SM
  </p>
  <p class="d-none d-md-block d-lg-none">
    MD
  </p>
  <p class="d-none d-lg-block d-xl-none">
    LG
  </p>
  <p class="d-none d-xl-block">
    XL
  </p>
</div>
